<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.faq") }}</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-plus"
        @click="data_hide = !data_hide"
        icon-pack="feather"
        >Add FAQ</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-12">
        <div class="vx-col sm:w-full w-full mb-2">
          <vs-input
            class="w-full"
            placeholder="Enter question"
            label="Question"
            v-model="question"
            name="question"
            v-validate="'required|min:3|max:200'"
          />
          <span class="text-danger text-sm" v-show="errors.has('question')">{{
            errors.first("question")
          }}</span>
        </div>
        <div class="vx-col sm:w-full w-full mb-2">
          <vs-input
            class="w-full"
            placeholder="Enter answer"
            label="Answer"
            v-model="answer"
            name="answer"
            v-validate="'required|min:3|max:200'"
          />
          <span class="text-danger text-sm" v-show="errors.has('answer')">{{
            errors.first("answer")
          }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" class="mr-3 mb-2" @click="addFaq()"
            >Add</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="resetForm()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="data_hide = !data_hide"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table stripe :data="users" search max-items="10">
        <template slot="thead">
          <vs-th>{{ $t("labels.faqid") }}</vs-th>
          <vs-th>{{ $t("labels.question") }}</vs-th>
          <vs-th>{{ $t("labels.answer") }}</vs-th>
          <vs-th>{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].sr_no }}
            </vs-td>

            <vs-td
              :data="data[indextr].code"
              class="word-break"
              style="width: 40% !important"
            >
              {{ data[indextr].code }}
            </vs-td>

            <vs-td
              :data="data[indextr].answer"
              class="word-break"
              style="width: 40% !important"
            >
              {{ data[indextr].answer }}
            </vs-td>

            <vs-td :data="data[indextr].email">
              <span>
                <vs-button
                  title="Delete"
                  class="m-1 float-left"
                  color="danger"
                  icon="icon-trash-2"
                  @click="DeleteAccount(data[indextr].id)"
                  icon-pack="feather"
                  size="small"
                ></vs-button>
                <vs-button
                  v-if="data[indextr].is_active"
                  @click.native="
                    BlockUnblock(data[indextr].id, data[indextr].is_active)
                  "
                  size="small"
                  title="Deactivate"
                  class="m-1 float-left"
                  color="black"
                  icon="icon-user-x"
                  icon-pack="feather"
                ></vs-button>
                <vs-button
                  v-if="!data[indextr].is_active"
                  @click.native="
                    BlockUnblock(data[indextr].id, data[indextr].is_active)
                  "
                  size="small"
                  title="Activate"
                  class="m-1 float-left"
                  color="gray"
                  icon="icon-user-check"
                  icon-pack="feather"
                ></vs-button>
              </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div style="height: 50px">
      <div class="float-left mt-5">
        <vs-pagination
          ref="paginationContact"
          :total="totalPage"
          v-model="currentPage"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    users: [],
    question: "",
    answer: "",
    classes: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getAllFaq();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllFaq();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        this.getAllFaq();
      }
    },
  },
  methods: {
    getAllFaq() {
      let input = {
        title: this.title,
        page: this.currentPage,
        perPage: this.perPage,
      };
      axios
        .post("faq/allFaq", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.faq;
          this.totalPage = Math.ceil(data.count / this.perPage);
          let page = this.$route.query.page;
          if (page) {
            this.currentPage = page;
          }
          console.log(this.users);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      (this.question = ""), (this.answer = "");
      this.$validator.reset();
    },
    BlockUnblock(id, status) {
      this.changeID = id;
      this.sts = status;
      let text = text;
      let title_model = title_model;
      if (status) {
        text = this.$t("strings.deactivate_faq");
        title_model = this.$t("labels.deactivate_faq");
      } else {
        text = this.$t("strings.activate_faq");
        title_model = this.$t("labels.activate_faq");
      }
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: title_model,
        text: text,
        acceptText: this.$t("labels.delete_button"),
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      let input = {
        is_active: !this.sts,
      };
      axios
        .post("faq/changeStatus/" + this.changeID, input)
        .then((response) => {
          let data = response.data;

          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });
          this.getAllFaq();
          this.changeID = null;
        })
        .catch((e) => {
          this.changeID = null;
          this.showError(e);
        });
    },
    DeleteAccount(id) {
      this.deleteID = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("labels.delete_faq"),
        text: this.$t("strings.delete_faq"),
        acceptText: this.$t("labels.delete_button"),
        accept: this.deleteUser,
      });
    },
    deleteUser() {
      // let input = {
      //   faq_id: this.deleteID,
      // };
      axios
        .get("faq/delete/" + this.deleteID)
        .then((response) => {
          let data = response.data;
          this.getAllFaq();
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });

          this.deleteID = null;
        })
        .catch((e) => {
          this.deleteID = null;
          this.showError(e);
        });
    },
    addFaq() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // this.button_loader(true, "#user-login");
          let input = {
            code: this.question,
            answer: this.answer,
          };
          axios
            .post("faq/addFaq", input)
            .then((response) => {
              let data = response.data;
              this.data_hide = !this.data_hide;
              this.$vs.notify({
                text: data.message,
                color: "success",
                position: "top-right",
              });
              (this.question = ""), (this.answer = "");
              this.$validator.reset();
              this.getAllFaq();
            })
            .catch((e) => {
              this.showError(e);
            });
        }
      });
    },
  },
  mounted() {
    this.getAllFaq();
  },
};
</script>

<style lang="scss" scoped>
.vs-tooltip{
  display: block !important;
}

</style>